import { useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as Yup from 'yup'

import { Container, Content } from './styles'
import { Button, Textbox } from '../../components/Form'
import { api } from '../../services/api'

const validation = Yup.object({
    otp: Yup.string().length(6, 'Código incorreto.').required('Insida o código.')
})

const initialValues = {
    otp: ''
}

export default function ConfirmationAccountOTP() {
	const location = useLocation()
    const history = useHistory()

    const usuario_criado = location?.state?.usuario_criado

    async function handleSubmit(values) {
        try {
            const email = localStorage.getItem('sigas-confirmation-account-temp-data')

            if(!email) {
                history.push('/login')

                return
            }

            await api.patch('confirmar_conta', {
                email,
                otp: values.otp
            })

            localStorage.removeItem('sigas-confirmation-account-temp-data')

            history.push('/login')

            toast.success('Tudo certo! Sua conta foi ativada. Faça login com sua senha.')
        } catch(e) {
            toast.error(e.msg)
        }
    }

    async function handleReenviarCodigoOTP() {
        try {
            const email = localStorage.getItem('sigas-confirmation-account-temp-data')

            if(!email) {
                history.push('/login')

                return
            }

            await api.post('usuario/reenviar_confirmacao', { email })

            toast.success('Acabamos de reenviar o link de confirmação. Acesse sua caixa de entrada.')
        } catch(e) {
            toast.error(e.msg)
        }
    }

    useEffect(() => {
        if(!usuario_criado) {
            history.push('/login')
        }
    }, [usuario_criado])

    if(!usuario_criado) {
        return null
    }

    return (
        <>
            <Container>
                <div className="space" style={{ width: '100%' }} />

                <div className="flex flex-col gap-4">
                    {usuario_criado && (
                        <div className="flex flex-col gap-4 bg-emerald-600 text-white mx-2 p-4 rounded-md text-slate-800 animated flash max-w-[315px]">
                            <p dangerouslySetInnerHTML={{
                                __html: `Enviamos um código para o seu WhatsApp e e-mail. Insira-o abaixo.`
                            }} />
                        </div>
                    )}
                    
                    <Content className="animated fadeIn delay-200ms bg-white text-slate-800">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validation}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <h1 className="text-slate-800">Digite o código recebido</h1>

                                    <Textbox
                                        name="otp"
                                        label="Código recebido"
										mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                    />

                                    <span 
                                        className="cursor-pointer py-2 px-3 text-sky-600 hover:opacity-70 mt-2" 
                                        onClick={() => { handleReenviarCodigoOTP() }}
                                    >
                                        Não recebeu o código?<br/>Clique para reenviar.
                                    </span>

                                    <Button type="submit" loading={isSubmitting}>Confirmar</Button>
                                </Form>
                            )}
                        </Formik>
                    </Content>
                </div>
            </Container>

        </>
    )
}